import { ReactNode } from "react"
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "./AppSidebar"
import Breadcrumb from "./Breadcrumb"
import Footer from "./Footer"
import { useTheme } from "@/components/theme/DynamicThemeProvider"

interface DashboardLayoutProps {
  children: ReactNode
  showBreadcrumb?: boolean
}

export function DashboardLayout({ children, showBreadcrumb = true }: DashboardLayoutProps) {
  const { branding, isCustomThemed } = useTheme();
  
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        
        <div className="flex-1 flex flex-col min-w-0">
          {/* Header with Sidebar Toggle */}
          <header className="h-12 sm:h-14 md:h-16 border-b bg-background flex items-center px-2 sm:px-3 md:px-6">
            <SidebarTrigger className="mr-2 md:mr-4" />
            <div className="flex-1 min-w-0 flex items-center gap-3">
              {isCustomThemed && branding?.logo_header_url && (
                <img 
                  src={branding.logo_header_url} 
                  alt="Logo" 
                  className="h-8 w-auto object-contain"
                />
              )}
              <h1 className="text-base sm:text-lg md:text-xl font-semibold truncate">
                {isCustomThemed && branding?.app_name ? branding.app_name : "Herzensempfehlung"}
              </h1>
            </div>
          </header>
          
          {/* Main Content */}
          <main className="flex-1 overflow-auto">
            {showBreadcrumb && (
              <div className="border-b bg-background px-2 sm:px-3 md:px-6 py-2 md:py-3">
                <Breadcrumb />
              </div>
            )}
            <div className="p-2 sm:p-3 md:p-4 lg:p-6 pb-0">
              {children}
            </div>
          </main>
          
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  )
}